module.exports = __webpack_public_path__ + "static/media/HayThereVideoBg.6d93c01c.mp4";